import React from 'react';

import { MissionStatement } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-about';

export const AboutMissionContainer: React.FC = () => {
  return (
    <MissionStatement
      title={lexemes.lxPageAboutMissionTitle}
      statement={lexemes.lxPageAboutMissionStatement}
    />
  );
};
